<template>
  <div class="content-container">
    <el-card class="box-card">
      <el-form :inline="true" label-width="120px" class="demo-form-inline">
        <!-- <el-form-item label="类型">
          <el-radio-group v-model="userType">
            <el-radio label="agentid">代理商</el-radio>
            <el-radio label="vendorid">加盟商</el-radio>
            <el-radio label="shopid">门店</el-radio>
          </el-radio-group>
        </el-form-item> -->
        <!-- <el-form-item label="代理商">
          <el-autocomplete
            v-model="agentName"
            :fetch-suggestions="querySearchAgent"
            placeholder="请输入代理商"
          ></el-autocomplete>
          {{ agentid }}
        </el-form-item>
        <el-form-item label="加盟商" v-if="userType === 'vendor'">
          <el-autocomplete
            v-model="vendorName"
            :fetch-suggestions="querySearchVendor"
            placeholder="请输入加盟商"
          ></el-autocomplete>
          {{ vendorid }}
        </el-form-item>
        <el-form-item label="门店" v-if="userType === 'shopid'">
          <el-autocomplete
            v-model="shopName"
            :fetch-suggestions="querySearchShop"
            placeholder="请输入代理商"
          ></el-autocomplete>
          {{ shopid }}
        </el-form-item> -->

        <agentVendorShop @select="selectHandler" />

        <br />
        <el-form-item label="统计方式">
          <el-radio-group v-model="timeType">
            <!-- <el-radio label="year">年度</el-radio> -->
            <el-radio label="month">按月</el-radio>
            <el-radio label="date">按日</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="账单日期">
          <el-date-picker
            v-model="billDate"
            type="daterange"
            range-separator="~"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :clearable="false"
            :picker-options="pickerOptions"
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="onSubmit"
            >查询</el-button
          >
        </el-form-item>
        <br />
        <el-form-item label="快捷:">
          <el-button type="info" effect="light" @click="setTimeWholeYear"
            >今年</el-button
          >
          <el-button type="info" effect="light" @click="setTimeHalfYear(0)"
            >上半年</el-button
          >
          <el-button type="info" effect="light" @click="setTimeHalfYear(1)"
            >下半年</el-button
          >
          <el-button type="info" effect="light" @click="setTimeQuarter(0)"
            >一季度</el-button
          >
          <el-button type="info" effect="light" @click="setTimeQuarter(1)"
            >二季度</el-button
          >
          <el-button type="info" effect="light" @click="setTimeQuarter(2)"
            >三季度</el-button
          >
          <el-button type="info" effect="light" @click="setTimeQuarter(3)"
            >四季度</el-button
          >
        </el-form-item>
        <br />
        <el-form-item label=" ">
          <el-button type="info" effect="light" @click="setLastMonth"
            >上月</el-button
          >
          <el-button type="info" effect="light" @click="setLastWeek"
            >上周</el-button
          >
          <el-button type="info" effect="light" @click="setThisMonth"
            >本月</el-button
          >
          <el-button type="info" effect="light" @click="setThisWeek"
            >本周</el-button
          >
          <el-button type="info" effect="light" @click="setThreeDays"
            >近三天</el-button
          >
          <el-button type="info" effect="light" @click="setToday"
            >今天</el-button
          >
        </el-form-item>
      </el-form>
    </el-card>
    <el-row class="m-mt20">
      <el-col :span="24">
        <ve-histogram
          :data="chartData"
          :title="{ text: title, left: 'center' }"
          :dataZoom="dataZoomOptions"
          :legend="{ top: 36 }"
          :grid="{ top: 80 }"
        >
          <div
            class="data-empty"
            v-if="!chartData.rows || !chartData.rows.length"
          >
            <i class="el-icon-warning" style="margin-right:1em;"></i>
            <span style="margin-right:1em;">抱歉，此次请求木有数据！😂</span>
          </div>
        </ve-histogram>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import moment from "moment";
import agentVendorShop from "@/components/layout/agentVendorShop";

export default {
  components: {
    agentVendorShop
  },
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          return !moment(time).isBetween(
            moment().subtract(1, "years"),
            moment()
          );
        }
      },
      timeType: "month",
      agentid: null,
      vendorid: null,
      shopid: null,

      agentName: "",
      vendorName: "",
      shopName: "",
      // agentListForPrompt: [],
      // vendorListForPrompt: [],
      // shopListForPrompt: [],
      // agentList: [],
      // vendorList: [],
      //filterVendorList: [],
      // shopList: [],
      // filterShopList: [],
      billDate: [moment().subtract(1, "months"), moment()],
      chartData: {},
      dataZoomOptions: {
        type: "slider"
      },
      title: "",
      userType: this.$getUserType()
    };
  },

  // watch: {
  //   agentName: {
  //     handler(newName, oldName) {
  //       if (newName != oldName) {
  //         console.log("agentName changed" + newName + oldName);
  //         this.agentid = this.$getAgentID(newName);

  //         if (this.agentid) {
  //           this.$queryVendorForPrompt(this.agentid, result => {
  //             this.vendorListForPrompt = result;
  //           });
  //         } else {
  //           this.vendorListForPrompt = [];

  //           this.vendorName = "";
  //           this.vendorid = "";
  //         }
  //       }
  //     }
  //   },
  //   vendorName: {
  //     handler(newName, oldName) {
  //       if (newName != oldName) {
  //         console.log("vendorName changed" + newName + oldName);
  //         this.vendorid = this.$getVendorID(newName);
  //         if (this.vendorid) {
  //           this.$queryShopForPrompt(this.vendorid, result => {
  //             this.shopListForPrompt = result;
  //           });
  //         } else {
  //           this.shopListForPrompt = [];
  //           this.shopName = "";
  //           this.shopid = "";
  //         }
  //       }
  //     }
  //   },
  //   shopName: {
  //     handler(newName, oldName) {
  //       if (newName != oldName) {
  //         console.log("shopName changed" + newName + oldName);
  //         this.shopid = this.$getShopID(newName);
  //       }
  //     }
  //   }
  // },

  methods: {
    selectHandler(x) {
      console.log("selectHandler", x);

      this.agentid = x.selectedAgent.agentid;
      this.vendorid = x.selectedVendor.vendorid;
      this.shopid = x.selectedShop.shopid;

      console.log(this.agentid, this.vendorid, this.shopid);
    },
    setTimeWholeYear() {
      this.billDate = [moment().startOf("year"), moment().endOf("year")];
    },
    setTimeHalfYear(index) {
      if (index == 0) {
        this.billDate = [
          moment().startOf("year"),
          moment()
            .month(5)
            .endOf("month")
        ];
      } else if (index == 1) {
        this.billDate = [
          moment()
            .month(6)
            .startOf("month"),
          moment().endOf("year")
        ];
      }
    },
    setTimeQuarter(index) {
      index = index * 3;
      this.billDate = [
        moment()
          .set("months", index)
          .set("date", 1),
        moment()
          .set("months", index + 3)
          .set("date", 1)
          .subtract(1, "days")
      ];
    },
    setLastMonth() {
      this.billDate = [
        moment()
          .subtract(1, "months")
          .set("date", 1),
        moment()
          .set("date", 1)
          .subtract(1, "days")
      ];
    },
    setLastWeek() {
      this.billDate = [
        moment()
          .week(moment().week() - 1)
          .startOf("week"),
        moment()
          .week(moment().week() - 1)
          .endOf("week")
      ];
    },

    setThisMonth() {
      this.billDate = [moment().startOf("month"), moment().endOf("month")];
    },
    setThisWeek() {
      this.billDate = [moment().startOf("week"), moment().endOf("week")];
    },
    setThreeDays() {
      this.billDate = [moment().subtract(2, "days"), moment()];
    },
    setToday() {
      this.billDate = [moment(), moment()];
    },

    onSubmit() {
      try {
        this.title = "";
        let params = {
          groupByUserType: this.userType,
          groupByTime: this.timeType,
          dateFrom: this.$ToDateString(this.billDate[0]),
          dateTo: this.$ToDateString(this.billDate[1])
        };
        console.log(this.userType);
        if (this.agentid && !this.vendorid && !this.shopid) {
          // if (!this.agentid) {
          //   this.$notify.error({
          //     title: "错误",
          //     message: "请输入代理商"
          //   });
          //   return;
          // }
          params.agentid = this.agentid;
          this.title += "代理商：";
          this.title += this.$getAgentName(this.agentid);
        } else if (this.agentid && this.vendorid && !this.shopid) {
          // if (!this.vendorid) {
          //   this.$notify.error({
          //     title: "错误",
          //     message: "请输入加盟商"
          //   });
          //   return;
          // }
          params.vendorid = this.vendorid;
          this.title += "加盟商：";
          this.title += this.$getVendorName(this.vendorid);
        } else if (this.agentid && this.vendorid && this.shopid) {
          // if (!this.shopid) {
          //   this.$notify.error({
          //     title: "错误",
          //     message: "请输入加盟商"
          //   });
          //   return;
          // }
          params.shopid = this.shopid;
          this.title += "门店：";
          this.title += this.$getShopName(this.shopid);
        } else {
          this.$notify.error({
            title: "错误",
            message: "请输入选项"
          });
          return;
        }

        this.title +=
          this.timeType === "year"
            ? "年度"
            : this.timeType === "month"
            ? "月度"
            : this.timeType === "date"
            ? "每日"
            : "";
        this.title += "账单统计";
        this.$axios(this.$urlMapping["查询账单统计"], {
          data: params
        }).then(result => {
          let columns = [
            "支付金额",
            "支付次数",
            "退款金额",
            "退款次数",
            "总金额"
          ];
          let rows = result.map(ele => {
            return {
              支付金额: ele.payment_amount,
              支付次数: ele.payment_count,
              退款金额: ele.refund_amount,
              退款次数: ele.refund_count,
              总金额: ele.total_amount,
              [`${this.timeType}`]: ele[this.timeType]
            };
          });
          columns.unshift(this.timeType);
          this.chartData = {
            columns,
            rows
          };

          console.log(this.chartData);
        });
      } catch (error) {
        this.$notify({
          title: "警告",
          message: `不正规操作：包含【${error}错误！】`,
          type: "error"
        });
      }
    }
  },
  async mounted() {
    // await this.queryAgent();
    // await this.queryVendor();
    // await this.getShops();
    // this.filterVendorList = this.vendorList.filter(
    //   ele => ele.agentid === this.agentid
    // );
    // if (this.filterVendorList.length === 0) {
    //   return;
    // }
    // this.vendorid = this.filterVendorList[0].vendorid;
    // this.filterShopList = this.filterVendorList.filter(
    //   ele => ele.shopOwner === this.vendorid
    // );
    // if (this.filterShopList.length === 0) {
    //   return;
    // }
    // this.shopid = this.filterShopList[0].shopid;
    // this.$queryAgentForPrompt(result => {
    //   this.agentListForPrompt = result;
    // });
    // this.$queryVendorForPrompt(null, result => {
    //   this.vendorListForPrompt = result;
    // });
    // this.$queryShopForPrompt(this.formInline.vendorid, result => {
    //   this.shopListForPrompt = result;
    // });
    // setTimeout(() => {
    //   this.onSubmit();
    // }, 1000);
  }
};
</script>

<style></style>
